/**
 * Legacy hash links
 *
 * The old Angular app used hash routing, so emails and bookmarks carry links such as
 * `https://hgv.motrv2.com/#/home/<jobId>`. BrowserRouter never sees the hash, so those
 * links would just land on the dashboard. Translate them into the React route before
 * the router (and the login redirect) read the URL.
 *
 * Runs as a side effect on import: `createBrowserRouter` reads the URL when the routes
 * module is evaluated, so this must be the first import in main.tsx.
 */

import { ROUTES } from './routes';

const GUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';

/** `#/home/<jobId>` → the dashboard with that job pre-selected. */
const HOME_JOB_LINK = new RegExp(`^#/home/(${GUID})/?(?:[?#].*)?$`, 'i');

const rewriteLegacyHashLink = (): void => {
  const { pathname, hash } = window.location;
  if (pathname !== '/' || !hash) return;

  const match = HOME_JOB_LINK.exec(hash);
  if (!match) return;

  // /dashboard resolves the user's landing tab and carries ?jobId through: the client
  // workspace opens it in My Requests, the internal dashboard opens it in WIP.
  const target = `${ROUTES.DASHBOARD.ROOT}?jobId=${encodeURIComponent(match[1].toLowerCase())}`;
  window.history.replaceState(window.history.state, document.title, target);
};

rewriteLegacyHashLink();
